import { z } from 'zod';

// ----------------------------------------------------------------------

export const signInCredentialsSchema = z.object({
  email: z.string().min(1).email(),
  password: z.string().min(1).min(6),
});

export type SignInCredentials = z.infer<typeof signInCredentialsSchema>;
